export type CardColorScheme =
  | "scout-blue"
  | "scout-blue-dark"
  | "scout-blue-pale"
  | "scout-blue-info"
  | "scout-red"
  | "scout-red-dark"
  | "scout-red-light"
  | "scout-tan"
  | "scout-tan-dark"
  | "scout-tan-light"
  | "scout-matrix-yellow"
  | "scout-matrix-green"
  | "scout-matrix-orange"
  | "yellow"
  | "blue"
  | "green"
  | "red"
  | "purple"
  | "gray";

export interface CardColorSet {
  border: string;
  gradientFrom: string;
  gradientTo: string;
  borderB: string;
  borderT?: string;
  title: string;
  icon: string;
  labelText: string;
  iconColor: string;
  itemTitle?: string;
  itemDate?: string;
  footerBg?: string;
  buttonText?: string;
  hoverBg?: string;
}

export const cardColors: Record<CardColorScheme, CardColorSet> = {
  // BSA blue color schemes
  "scout-blue": {
    border: "border-scout-blue/20",
    gradientFrom: "from-scout-blue/10",
    gradientTo: "to-scout-blue/5",
    borderB: "border-scout-blue/20",
    borderT: "border-scout-blue/20",
    title: "text-scout-blue-dark",
    icon: "text-scout-blue",
    labelText: "text-scout-blue",
    iconColor: "text-scout-blue",
    itemTitle: "text-scout-blue-dark",
    itemDate: "text-gray-500",
    footerBg: "bg-scout-blue/5",
    buttonText: "text-scout-blue",
    hoverBg: "hover:bg-scout-blue/5",
  },
  "scout-blue-dark": {
    border: "border-scout-blue-dark/20",
    gradientFrom: "from-scout-blue-dark/10",
    gradientTo: "to-scout-blue-dark/5",
    borderB: "border-scout-blue-dark/20",
    borderT: "border-scout-blue-dark/20",
    title: "text-scout-blue-dark",
    icon: "text-scout-blue-dark",
    labelText: "text-scout-blue-dark",
    iconColor: "text-scout-blue-dark",
    itemTitle: "text-scout-blue-dark",
    itemDate: "text-scout-blue-dark",
    footerBg: "bg-scout-blue-dark/5",
    buttonText: "text-scout-blue-dark",
    hoverBg: "hover:bg-scout-blue-dark/5",
  },
  "scout-blue-pale": {
    border: "border-scout-blue-pale/40",
    gradientFrom: "from-scout-blue-pale/20",
    gradientTo: "to-scout-blue-pale/10",
    borderB: "border-scout-blue-pale/40",
    borderT: "border-scout-blue-pale/40",
    title: "text-scout-blue-dark",
    icon: "text-scout-blue",
    labelText: "text-scout-blue",
    iconColor: "text-scout-blue",
    itemTitle: "text-scout-blue-dark",
    itemDate: "text-scout-blue",
    footerBg: "bg-scout-blue-pale/10",
    buttonText: "text-scout-blue",
    hoverBg: "hover:bg-scout-blue-pale/20",
  },
  "scout-blue-info": {
    border: "border-scout-blue-info/20",
    gradientFrom: "from-scout-blue-info/10",
    gradientTo: "to-scout-blue-info/5",
    borderB: "border-scout-blue-info/20",
    borderT: "border-scout-blue-info/20",
    title: "text-scout-blue-dark",
    icon: "text-scout-blue-info",
    labelText: "text-scout-blue-info",
    iconColor: "text-scout-blue-info",
    itemTitle: "text-scout-blue-dark",
    itemDate: "text-scout-blue-info",
    footerBg: "bg-scout-blue-info/5",
    buttonText: "text-scout-blue-info",
    hoverBg: "hover:bg-scout-blue-info/5",
  },

  // BSA red color schemes
  "scout-red": {
    border: "border-scout-red/20",
    gradientFrom: "from-scout-red/10",
    gradientTo: "to-scout-red/5",
    borderB: "border-scout-red/20",
    borderT: "border-scout-red/20",
    title: "text-scout-red-dark",
    icon: "text-scout-red",
    labelText: "text-scout-red",
    iconColor: "text-scout-red",
    itemTitle: "text-scout-red-dark",
    itemDate: "text-scout-red",
    footerBg: "bg-scout-red/5",
    buttonText: "text-scout-red",
    hoverBg: "hover:bg-scout-red/5",
  },
  "scout-red-dark": {
    border: "border-scout-red-dark/20",
    gradientFrom: "from-scout-red-dark/10",
    gradientTo: "to-scout-red-dark/5",
    borderB: "border-scout-red-dark/20",
    borderT: "border-scout-red-dark/20",
    title: "text-scout-red-dark",
    icon: "text-scout-red-dark",
    labelText: "text-scout-red-dark",
    iconColor: "text-scout-red-dark",
    itemTitle: "text-scout-red-dark",
    itemDate: "text-scout-red-dark",
    footerBg: "bg-scout-red-dark/5",
    buttonText: "text-scout-red-dark",
    hoverBg: "hover:bg-scout-red-dark/5",
  },
  "scout-red-light": {
    border: "border-scout-red-light/30",
    gradientFrom: "from-scout-red-light/15",
    gradientTo: "to-scout-red-light/5",
    borderB: "border-scout-red-light/30",
    borderT: "border-scout-red-light/30",
    title: "text-scout-red-dark",
    icon: "text-scout-red",
    labelText: "text-scout-red",
    iconColor: "text-scout-red",
    itemTitle: "text-scout-red-dark",
    itemDate: "text-scout-red",
    footerBg: "bg-scout-red-light/15",
    buttonText: "text-scout-red",
    hoverBg: "hover:bg-scout-red-light/15",
  },

  // BSA tan color schemes
  "scout-tan": {
    border: "border-scout-tan/40",
    gradientFrom: "from-scout-tan/20",
    gradientTo: "to-scout-tan/10",
    borderB: "border-scout-tan/40",
    borderT: "border-scout-tan/40",
    title: "text-scout-gray-dark",
    icon: "text-scout-blue",
    labelText: "text-scout-blue-dark",
    iconColor: "text-scout-blue",
    itemTitle: "text-scout-gray-dark",
    itemDate: "text-scout-blue-dark",
    footerBg: "bg-scout-tan/10",
    buttonText: "text-scout-blue",
    hoverBg: "hover:bg-scout-tan/20",
  },
  "scout-tan-dark": {
    border: "border-scout-tan-dark/20",
    gradientFrom: "from-amber-100",
    gradientTo: "to-amber-50",
    borderB: "border-scout-tan-dark/20",
    borderT: "border-scout-tan-dark/20",
    title: "text-scout-blue-dark",
    icon: "text-scout-blue",
    labelText: "text-scout-blue-dark",
    iconColor: "text-scout-blue",
    itemTitle: "text-scout-blue-dark",
    itemDate: "text-scout-blue",
    footerBg: "bg-amber-50",
    buttonText: "text-scout-blue",
    hoverBg: "hover:bg-amber-50",
  },
  "scout-tan-light": {
    border: "border-scout-tan-light/30",
    gradientFrom: "from-scout-tan-light/50",
    gradientTo: "to-scout-tan-light/20",
    borderB: "border-scout-tan/30",
    borderT: "border-scout-tan-light/30",
    title: "text-scout-gray-dark",
    icon: "text-scout-blue",
    labelText: "text-scout-blue-dark",
    iconColor: "text-scout-blue",
    itemTitle: "text-scout-gray-dark",
    itemDate: "text-scout-blue-dark",
    footerBg: "bg-scout-tan-light/20",
    buttonText: "text-scout-blue",
    hoverBg: "hover:bg-scout-tan-light/30",
  },

  // BSA matrix color schemes
  "scout-matrix-yellow": {
    border: "border-amber-300/50",
    gradientFrom: "from-amber-100",
    gradientTo: "to-amber-50",
    borderB: "border-amber-300/50",
    borderT: "border-amber-300/50",
    title: "text-amber-900",
    icon: "text-amber-600",
    labelText: "text-amber-700",
    iconColor: "text-amber-600",
    itemTitle: "text-amber-900",
    itemDate: "text-amber-600",
    footerBg: "bg-amber-50",
    buttonText: "text-amber-600",
    hoverBg: "hover:bg-amber-50",
  },
  "scout-matrix-green": {
    border: "border-scout-matrix-green/20",
    gradientFrom: "from-scout-matrix-green/10",
    gradientTo: "to-scout-matrix-green/5",
    borderB: "border-scout-matrix-green/20",
    borderT: "border-scout-matrix-green/20",
    title: "text-scout-gray-dark",
    icon: "text-emerald-600",
    labelText: "text-emerald-700",
    iconColor: "text-emerald-600",
    itemTitle: "text-scout-gray-dark",
    itemDate: "text-emerald-600",
    footerBg: "bg-scout-matrix-green/5",
    buttonText: "text-emerald-600",
    hoverBg: "hover:bg-scout-matrix-green/10",
  },
  "scout-matrix-orange": {
    border: "border-scout-matrix-orange/20",
    gradientFrom: "from-scout-matrix-orange/10",
    gradientTo: "to-scout-matrix-orange/5",
    borderB: "border-scout-matrix-orange/20",
    borderT: "border-scout-matrix-orange/20",
    title: "text-scout-gray-dark",
    icon: "text-orange-600",
    labelText: "text-orange-700",
    iconColor: "text-orange-600",
    itemTitle: "text-scout-gray-dark",
    itemDate: "text-orange-600",
    footerBg: "bg-scout-matrix-orange/5",
    buttonText: "text-orange-600",
    hoverBg: "hover:bg-scout-matrix-orange/10",
  },

  // Legacy color schemes (for backward compatibility)
  yellow: {
    border: "border-yellow-100",
    gradientFrom: "from-yellow-50",
    gradientTo: "to-yellow-100/50",
    borderB: "border-yellow-100",
    borderT: "border-yellow-100",
    title: "text-yellow-900",
    icon: "text-yellow-500",
    labelText: "text-yellow-500",
    iconColor: "text-yellow-600",
    itemTitle: "text-yellow-800",
    itemDate: "text-yellow-500",
    footerBg: "bg-yellow-50/50",
    buttonText: "text-yellow-600",
    hoverBg: "hover:bg-yellow-50",
  },
  blue: {
    border: "border-blue-100",
    gradientFrom: "from-blue-50",
    gradientTo: "to-blue-100/50",
    borderB: "border-blue-100",
    borderT: "border-blue-100",
    title: "text-blue-900",
    icon: "text-blue-500",
    labelText: "text-blue-500",
    iconColor: "text-blue-600",
    itemTitle: "text-blue-800",
    itemDate: "text-blue-500",
    footerBg: "bg-blue-50/50",
    buttonText: "text-blue-600",
    hoverBg: "hover:bg-blue-50",
  },
  green: {
    border: "border-green-100",
    gradientFrom: "from-green-50",
    gradientTo: "to-green-100/50",
    borderB: "border-green-100",
    borderT: "border-green-100",
    title: "text-green-900",
    icon: "text-green-500",
    labelText: "text-green-500",
    iconColor: "text-green-600",
    itemTitle: "text-green-800",
    itemDate: "text-green-500",
    footerBg: "bg-green-50/50",
    buttonText: "text-green-600",
    hoverBg: "hover:bg-green-50",
  },
  red: {
    border: "border-red-100",
    gradientFrom: "from-red-50",
    gradientTo: "to-red-100/50",
    borderB: "border-red-100",
    borderT: "border-red-100",
    title: "text-red-900",
    icon: "text-red-500",
    labelText: "text-red-500",
    iconColor: "text-red-600",
    itemTitle: "text-red-800",
    itemDate: "text-red-500",
    footerBg: "bg-red-50/50",
    buttonText: "text-red-600",
    hoverBg: "hover:bg-red-50",
  },
  purple: {
    border: "border-purple-100",
    gradientFrom: "from-purple-50",
    gradientTo: "to-purple-100/50",
    borderB: "border-purple-100",
    borderT: "border-purple-100",
    title: "text-purple-900",
    icon: "text-purple-500",
    labelText: "text-purple-500",
    iconColor: "text-purple-600",
    itemTitle: "text-purple-800",
    itemDate: "text-purple-500",
    footerBg: "bg-purple-50/50",
    buttonText: "text-purple-600",
    hoverBg: "hover:bg-purple-50",
  },
  gray: {
    border: "border-gray-100",
    gradientFrom: "from-gray-50",
    gradientTo: "to-gray-100/50",
    borderB: "border-gray-100",
    borderT: "border-gray-100",
    title: "text-gray-900",
    icon: "text-gray-500",
    labelText: "text-gray-500",
    iconColor: "text-gray-600",
    itemTitle: "text-gray-800",
    itemDate: "text-gray-500",
    footerBg: "bg-gray-50/50",
    buttonText: "text-gray-600",
    hoverBg: "hover:bg-gray-50",
  },
};

// Helper function to get color scheme with fallback
export const getCardColorScheme = (
  colorScheme: CardColorScheme | undefined,
): CardColorSet => {
  if (!colorScheme) return cardColors["scout-blue"];
  return cardColors[colorScheme] || cardColors["scout-blue"];
};
